// Load More Reveal functionality - shows hidden products without AJAX
const loadMoreReveal = () => {
	document.querySelectorAll('.js-load-more-reveal').forEach((button) => {
		button.addEventListener('click', function () {
			const productsPerPage = parseInt(this.dataset.productsPerPage);
			const hiddenProducts = document.querySelectorAll(
				'.collection-product-card.load-more-hidden'
			);

			// Add loading state
			this.setAttribute('disabled', '');
			this.classList.add('loading');

			// Show the next batch of products
			let shownCount = 0;
			hiddenProducts.forEach((product) => {
				if (shownCount < productsPerPage) {
					product.classList.remove('load-more-hidden');
					shownCount++;
				}
			});

			// Update classes for border display (based on per_row settings)
			updateProductCardClasses();

			// Attach size chart listeners to newly revealed products
			if (typeof attachSizeChartListeners === 'function') {
				attachSizeChartListeners();
			}

			// Remove loading state
			setTimeout(() => {
				this.removeAttribute('disabled');
				this.classList.remove('loading');

				// Check if there are more products to show
				const remainingHidden = document.querySelectorAll(
					'.collection-product-card.load-more-hidden'
				);
				if (remainingHidden.length === 0) {
					this.remove(); // Remove the button if no more products to show
				}
			}, 100); // Short delay to show loading state
		});
	});
};

// Function to update product card classes after new products are revealed
function updateProductCardClasses() {
	const perRow = parseInt(
		document
			.getElementById('product-grid')
			.style.getPropertyValue('--per-row') || 3
	);
	const visibleCards = document.querySelectorAll(
		'.collection-product-card:not(.load-more-hidden)'
	);

	visibleCards.forEach((card, index) => {
		// Remove any existing hide_border class
		card.classList.remove('hide_border');

		// Add hide_border class to the last item in each row
		if ((index + 1) % perRow === 0) {
			card.classList.add('hide_border');
		}
	});
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function () {
	loadMoreReveal();
});

// Also initialize immediately in case this script loads after DOMContentLoaded
loadMoreReveal();
